export default "__VITE_ASSET__COOCo99F__"